import React, { Component, Fragment } from 'react';
import * as d3 from 'd3'
import "./pie-chart.css";
import {getColor} from "../../utilities/getColor";

export default class PieChart extends Component {

  state = {
    tooltipIsShown: false,
    tooltip: {
      term: "",
      sentiment: "",
      primary: "",
      count: "",
      x: "",
      y: ""
    }
  };

  drawChart = () => {
    const showTooltip = ({x, y, term, sentiment, count, percent, primary}) => {
      this.setState({
        tooltipIsShown: true,
        tooltip: {
          term,
          sentiment,
          count,
          primary,
          percent,
          x,
          y
        }
      })
    };

    const hideTooltip = () => {
      this.setState({tooltipIsShown: false})
    };

    const { data, height, value } = this.props;
    const width = 300;
    const radius = height / 2 - 10;
    const pie = d3.pie()
      .sort(null)
      .value(function(d) { return d.count; });

    const path = d3.arc()
      .outerRadius(radius)
      .innerRadius(radius - 40);

    const biggerPath = d3.arc()
      .outerRadius(radius + 10)
      .innerRadius(radius - 40);

    const svg = d3.select(`#${this.props.svgId}`);
    const g = svg.append("g")
      .attr(
        "transform",
        `translate(${ width / 2 }, ${ height / 2 })`);
    const arcBound = g.selectAll(".arc")
      .data(pie(data));

    let arc = arcBound
      .enter()
      .append("g")
      .attr("class", "arc")
      .on("mouseover", function(d, i) {
        const pathTarget = d3.select(this.firstChild).transition().duration(300);
        pathTarget.attr("d", biggerPath);
      })
      .on("mousemove", function(d) {
        const x = d3.event.clientX;
        const y = d3.event.clientY;
        showTooltip({
          x,
          y,
          term: d.data.term,
          count: d.data.count,
          percent: d.data.percent,
          sentiment: d.data.sentiment,
          primary: d.data.primary
        });
      })
      .on("mouseout", function(d, i) {
        const pathTarget = d3.select(this.firstChild).transition().duration(300);
        pathTarget.attr("d", path);
        hideTooltip();
      })


    arc.append("path")
      .attr("d", path)
      .attr("fill", function(d,i) {
        return getColor({
          fromd3: true,
          top: d.data.term,
          sentiment: d.data.sentiment,
          primary: d.data.primary,
          d,
          i
        });
      })
      .each(function(d) {
        this._current = d;
      });

    arc.append("text")
      .attr("x", function(d) { return path.centroid(d)[0] - 10 })
      .attr("y", function(d) { return path.centroid(d)[1] })
      .attr("class", "pie_chart_text")
      .attr("dy", "0.35em")
      .attr("fill", "white")
      .attr("font-weight", '300')
      .text(function(d) {
        const percent = parseFloat(d.data.percent);
        return percent >= 4 ? `${percent}%` : null;
      })
      .each(function(d) {
        this._current = d;
      });

    this.update = function(newData) {

      const arc = g.selectAll(".arc")
        .data(pie(newData))
        .enter()
        .append("g")
        .attr("class", "arc")
        .on("mouseover", function(d, i) {
          const pathTarget = d3.select(this.firstChild).transition().duration(300);
          pathTarget.attr("d", biggerPath);
        })
        .on("mousemove", function(d) {
          const x = d3.event.clientX;
          const y = d3.event.clientY;
          showTooltip({
            x,
            y,
            term: d.data.term,
            count: d.data.count,
            percent: d.data.percent,
            sentiment: d.data.sentiment,
            primary: d.data.primary
          });
        })
        .on("mouseout", function(d, i) {
          const pathTarget = d3.select(this.firstChild).transition().duration(300);
          pathTarget.attr("d", path);
          hideTooltip();
        })

      arc
        .append("path")
        .attr("d", path)
        .attr("fill", function(d,i) {
          return getColor({
            fromd3: true,
            top: d.data.term,
            sentiment: d.data.sentiment,
            primary: d.data.primary,
            d,
            i
          });
        })
        .each(function(d) {
          this._current = d;
        });

      arc.append("text")
        .attr("x", function(d) { return path.centroid(d)[0] - 10 })
        .attr("y", function(d) { return path.centroid(d)[1] })
        .attr("class", "pie_chart_text")
        .attr("dy", "0.35em")
        .attr("fill", "white")
        .attr("font-weight", '300')
        .text(function(d) {
          const percent = parseFloat(d.data.percent);
          return percent >= 4 ? `${percent}%` : null;
        });

      g.selectAll(".arc")
        .data(pie(newData))
        .exit()
        .remove();

      svg
        .selectAll("path")
        .data(pie(newData))
        .transition()
        .attr("d", path)
        .attr("fill", function(d,i) {
          return getColor({
            fromd3: true,
            top: d.data.term,
            sentiment: d.data.sentiment,
            primary: d.data.primary,
            d,
            i
          });
        })
        .duration(750).attrTween("d", arcTween);
      svg
        .selectAll("text")
        .data(pie(newData))
        .transition()
        .duration(750)
        .attr("x", function(d) {return path.centroid(d)[0] - 10})
        .attr("y", function(d) { return path.centroid(d)[1] })
        .text(function(d) {
          const percent = parseFloat(d.data.percent);
          return percent >= 4 ? `${percent}%` : null;
        });
    };

    function arcTween(newData) {
      const i = d3.interpolate(this._current, newData);
      this._current = i(1);
      return function(t) {
        return path(i(t));
      };
    }
  };

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.data) !== JSON.stringify(this.props.data)) {
      this.update(this.props.data);
    }
  }

  componentDidMount() {
    this.drawChart();
  }

  render() {
    const { valueName, value, title, width, height, svgId } = this.props;
    return (
      <Fragment>
        <svg
          width={width}
          height={height}
          id={svgId}
        />
        <div style={{
          display: this.state.tooltipIsShown ? 'flex' : 'none',
          position: 'fixed',
          top: this.state.tooltip.y,
          left: this.state.tooltip.x + 30,
        }}
          className="pie_chart__tooltip"
        >
          <span className="bold">{valueName}</span>
          <span>{this.state.tooltip[value]}</span>
          <span className="bold">Count: </span><span>{this.state.tooltip.count}</span>
          <span className="bold">Percent: </span><span>{this.state.tooltip.percent}%</span>
        </div>

      </Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/pie-chart/pie-chart-component.js